import { render, staticRenderFns } from "./Observaciones.vue?vue&type=template&id=c01f1a34&scoped=true"
import script from "./Observaciones.vue?vue&type=script&lang=js"
export * from "./Observaciones.vue?vue&type=script&lang=js"
import style0 from "./Observaciones.vue?vue&type=style&index=0&id=c01f1a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01f1a34",
  null
  
)

export default component.exports